import axios from '../index'

export const _getModerators = (data, paging) => axios.get(`/moderators/?page=${paging.page}&count=${paging.count}&phrase=${paging.phrase}`, data)

export const _createModerator = (data) => axios.post('/moderators', data)

export const _editModerator = (data) => axios.patch(`/moderators/${data.id}`, data)

export const _deleteModerator = (data) => axios.delete(`/moderators/${data.id}`, data)